/* Import Css Style */
import './styles/FooterHome_Comp1.css'

/* external assets */
import BPISosJeunesPoussesEntrepreneuriat from './../assets/BPI.png'
import citelab from './../assets/citelab.jpg'
import LogoGrenobleAlpesMetropoleSosJeunesPoussesEntrepreneuriat from './../assets/Metropole.png'
import LogoServiceCivique from './../assets/Logo_Service_civique.png'
import LogoCapBerriat from './../assets/Logo-Cap-Berriat.png'
import cafeDesComp from './../assets/cafeDesComp.jpeg'
import NewsFm from './../assets/NewsFm.png'
import StreetCoiff from './../assets/StreetCoiff.jpg'
import champiloop from './../assets/Champiloop.png'
import hibisJuice from './../assets/hibis-Juice.jpeg'
import tag from './../assets/tag.png'
import TREMPLINDETAILLONS from './../assets/tremplin_detaillants.jpeg'
import fdjunited from './../assets/fdj_foundation.png'
import BNPPARIBAS from './../assets/bnp_paribas_fondation.png'
import logoQuartier from './../assets/logo-quartier.png'
import fondationDeFrance from './../assets/fondation_de_france.jpeg'
import logoQuartier2 from './../assets/logo-quartier-2.png'
import frenchTechTremplin from './../assets/frenchTechTremplin.png'
import act4Talent from './../assets/act4Talend.png'
import prefIsere from './../assets/Pref.png'
import addie from './../assets/ADIE_LOGO_RVB_1000px-removebg-preview.png'
import laCapsule from './../assets/La-capsule-black.png'
import sosjpfontaine from './../assets/sosjp-fontaine.jpeg'
import sosjpechirolles from './../assets/sosjp-echirolles.jpeg'
import projetBanlieue from './../assets/projet_banlieue.png'
import Time2start from './../assets/time2start.jpg'
import logoCci from './../assets/CCI.png'
import financalConsulting from '../assets/financalConsulting.jpeg'
import CMA from './../assets/CMA.png'
import FrenchTechAlpes from './../assets/French-Tech-Alpes.png'
import ReseauEntreprendreIsere from './../assets/réseau-entreprendre-isere.png'
import ZAPeuplier from './../assets/ZA-peupliers.jpeg'
import Soleeo from './../assets/Soleeo.png'
import MLSI from './../assets/MLSI.png'
import FDVA from './../assets/FDVA.png'
import quartier from '../assets/quartiers.jpeg'
import villeFontaine from '../assets/logofontaine.png' 
import elior from '../assets/Elior.jpeg'
import france_travail from '../assets/Logo_France_Travail_RVB_Horizontal_Coul_Positif.svg'

export const FooterHome_Comp1 = () =>{

    const handleClick = (LINK) => {
        const win = window.open(LINK, "_blank");
        win.focus();
    };

    return(
        <div class="FooterHome_Comp1_Container">
            <div class="TextFooterHome_Comp1">
                Parce qu'il faut être financé par <br/>les meilleurs <div style={{fontSize: '2.5rem', fontWeight: 'bolder'}} class={"UnderLineHeader"}>pour grandir</div>

            </div>
            <div class="FooterHome_Comp1_logos_containers" style={{ gridTemplateColumns:'1fr 1fr 1fr 1fr'}}>
                <img src={BPISosJeunesPoussesEntrepreneuriat} alt="Logo BPI" onClick={() => handleClick("https://moncompte.bpifrance.fr/redirect?goto=https%3A%2F%2Fmoncompte.bpifrance.fr%3A443%2Fam%2Foauth2%2Frealms%2Froot%2Frealms%2Fmcb%2Fauthorize%3Fclient_id%3Dbpi-creation%26redirect_uri%3Dhttps%3A%2F%2Fbpifrance-creation.fr%2Fopenid-connect%2Fmcb_cpc%26scope%3Dopenid%2520profile%2520email%26response_type%3Dcode%26acr_values%3Dregister%26acr%3Dregister%26acr_sig%3DBpfu6zmPQzpUZfwc2muDiWBu9Lipb1isP6VbfpZy3DU&acr_values=register&realm=/mcb&service=RegistrationSDK")} />
                <img onClick={() => handleClick("https://www.grenoblealpesmetropole.fr/")} src={LogoGrenobleAlpesMetropoleSosJeunesPoussesEntrepreneuriat} alt="Métropole grenoble" className="Metropole_Grenoble_FooterHome_Comp1" />
                <img onClick={() => handleClick("https://www.isere.gouv.fr/")} src={prefIsere} alt="Préfécture de l'isère" className="Pref_Isere" />
                <img onClick={() => handleClick("https://ville-fontaine.fr/")} src={villeFontaine} alt="Ville Fontaine" />
                <img onClick={() => handleClick("https://fondation.bnpparibas/")} src={BNPPARIBAS} alt="Fondation BNP Paribas" />
                <img onClick={() => handleClick("https://www.fdjunited.com/fr/fondation-fdjunited/")} src={fdjunited} alt="FDJ Foundation" />
                
                <img onClick={() => handleClick("https://entrepreneuriat-quartiers-2030.fr/")} src={logoQuartier} alt="Entrepreneuriat quartiers 2030" />
                <img onClick={() => handleClick("https://entrepreneuriat-quartiers-2030.fr/")} src={logoQuartier2} alt="Entrepreneuriat quartiers 2030" />
                <img onClick={() => handleClick("https://www.fondationdefrance.org/fr/")} src={fondationDeFrance} alt="Foundation de France" />
                <img onClick={() => handleClick("https://www.eliorgroup.com/fr")} src={elior} alt="Groupe Elior France" />

                <img style={{gridRow: 2, gridColumn: 2}} onClick={() => handleClick("https://www.isere.fr/")} src={"https://www.isere.fr/sites/default/files/2025-05/logo-isere.svg"} alt="Isére département" />
                <img style={{gridRow: 2, gridColumn: 3}} onClick={() => handleClick("https://www.associations.gouv.fr/FDVA.html")} src={FDVA} alt="FDVA" />

            </div>
            <div style={{marginTop:'150px'}}> </div>

            <div className="TextFooterHome_Comp1">
                Parce qu'il faut être reconnu par <br/>les meilleurs <div
                style={{fontSize: '2.5rem', fontWeight: 'bolder'}} className={"UnderLineHeader"}>pour briller</div>

            </div>





            <div className="FooterHome_Comp1_logos_containers" >
                <img onClick={() => handleClick("https://www.citeslab.fr/")} src={citelab} alt="CitesLab" />
                <img onClick={() => handleClick("https://projet-banlieues.fondation.bnpparibas/fr/")} src={projetBanlieue} alt="Projet banlieue fondation bnpparibas" />

                <img src={LogoServiceCivique} alt="Logo Service Civique" onClick={() => handleClick("https://www.service-civique.gouv.fr/")}/>
                <img src={TREMPLINDETAILLONS} alt="Tremplin solidaire" onClick={() => handleClick("https://www.ledauphine.com/social/2024/12/07/isere-grenoble-un-bureau-de-tabac-recompense-pour-son-projet-solidaire")}/>
                <img src={act4Talent} alt="Logo act4talent" onClick={() => handleClick("https://www.act4-talents.fr/")}/>

                <img src={frenchTechTremplin} alt="Logo frenchTechTremplin" onClick={() => handleClick("https://lafrenchtech.com/fr/la-france-aide-les-startup/tremplin/")}/>
 </div>

            <div style={{marginTop:'150px'}}> </div>
            <div className="TextFooterHome_Comp1">
                Parce qu'il faut s'entourer <br/>des meilleurs <div
                style={{fontSize: '2.5rem', fontWeight: 'bolder'}} className={"UnderLineHeader"}>pour réussir</div>


            </div>

            <div className="TextFooterGroup_Comp1">
               <div style={{fontWeight: 'bold'}} className={"UnderLineHeader"}>Pour être accompagné afin d'entreprendre</div>
            </div>


            <div className='FooterHome_Comp1_logos_containers' style={{marginBottom: '5vh'}}>
            <img src={LogoCapBerriat} alt="Logo Cap Berriat" onClick={() => handleClick("http://www.cap-berriat.com/")}/>
            <img src={addie} alt="Logo D'Addie" onClick={() => handleClick("https://www.adie.org/")}/>
            <img src={Time2start} alt="Logo De Time2start" onClick={() => handleClick("https://time2start.fr/")}/>
            <img src={logoCci} alt="Logo De La CCI" onClick={() => handleClick("https://www.cci.fr/")}/>
            <img src={CMA} alt="Logo De La CMA" onClick={() => handleClick("https://www.artisanat.fr/")}/>
            <img src={financalConsulting} alt="Logo Financal Consulting" onClick={() => handleClick("https://www.linkedin.com/in/ismaelaganessi/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app")}/>
            <img src={FrenchTechAlpes} alt="Logo French Tech Alpes" onClick={() => handleClick("https://www.ftalps.com/territoires/grenoble/")}/>
            <img src={ReseauEntreprendreIsere} alt="Logo Reseau Entreprendre Isere" onClick={() => handleClick("https://www.reseau-entreprendre.org/isere/")}/>
           
            </div>

            <div className="TextFooterGroup_Comp1">
               <div style={{fontWeight: 'bold'}} className={"UnderLineHeader"}>Pour avoir un local/bureau/domiciliation</div>
            </div>


            <div className='FooterHome_Comp1_logos_containers noamrg' style={{ marginTop: '2vh', marginBottom: '5vh', gridTemplateRows: '1fr', gridTemplateColumns:'1fr 1fr 1fr 1fr'}}>
            <img src={laCapsule} alt="Logo La Capsule" onClick={() => handleClick("http://www.cap-berriat.com/")}/>
{/*             <img src={quartier} alt="Logo quartier" onClick={() => handleClick("https://quartiersactifs.fr/")}/>
 */}
            
            <img src={sosjpfontaine} alt="Sosjp Fontaine" onClick={() => handleClick("https://www.affiches.fr/infos/societe/lassociation-sos-jeunes-pousses-accompagne-les-entrepreneurs-des-qvp/")}/>
            <img src={sosjpechirolles} alt="Sosjp Echirolles" onClick={() => handleClick("https://www.ledauphine.com/economie/2022/04/02/isere-echirolles-sos-jeunes-pousses-supporte-l-entreprenariat-au-feminin")}/>

            <img src={ZAPeuplier} alt="Logo Za Peuplier" onClick={() => handleClick("https://www.grenoblealpesmetropole.fr/cms_viewFile.php?idtf=5435&path=ZA-peupliers-2024.pdf")}/>


 </div>




        <div className="TextFooterGroup_Comp1">
               <div style={{fontWeight: 'bold'}} className={"UnderLineHeader"}>Pour potentiellement avoir une rémunération durant son aventure entrepreneuriale </div>
        </div>

            <div className="FooterHome_Comp1_logos_containers" style={{marginBottom: '30px', gridTemplateRows: '1fr', gridTemplateColumns:'1fr 1fr 1fr'}}>

            <img src={Soleeo} alt="Logo Soleeo" onClick={() => handleClick("https://www.soleeo.fr/")} style={{marginTop: '2vh', marginBottom: '2vh'}}/>
            <img src={MLSI} alt="Logo MLSI" onClick={() => handleClick("https://www.missionlocale-si.com/")}/>
            <img  src={france_travail} alt="Logo France Travail" onClick={() => handleClick("https://www.pole-emploi.fr/accueil/")}/>

                
            </div>



            <div className="TextFooterGroup_Comp1" style={{fontWeight: 'bold', marginBottom: '20px'}} >
               <div className={"UnderLineHeader"} >Pour communiquer avec nos partenaires</div>
        </div>

            <div className="FooterHome_Comp1_logos_containers" style={{gridTemplateColumns:'1fr 1fr 1fr 1fr'}}>

         <img src={NewsFm} alt="Logo De News Fm" onClick={() => handleClick("https://www.radio-newsfm.com/")}/>


                <img src={cafeDesComp} alt="Logo cafe des competence" onClick={() => handleClick("https://linktr.ee/cafedescompetences?utm_source=linktree_profile_share&ltsid=6c9311bd-ccc6-48a5-beb3-36e6e81d50d3")}/>
                <img src={StreetCoiff} alt="Logo De Street'Coiff" onClick={() => handleClick("https://www.instagram.com/street_coiff_officiel/?hl=fr")}/>
                <img src={champiloop} alt="Logo De Champiloop" onClick={() => handleClick("https://www.champiloop.com/")}/>
                <img src={hibisJuice} alt="Logo De Hibis Juice" onClick={() => handleClick("https://linktr.ee/HIBISJUICE?utm_source=linktree_profile_share&ltsid=533537ac-aba4-4d9e-aae3-b5354a7ec577")}/>
                <img src={tag} alt="Logo De Tag" onClick={() => handleClick("https://www.m-tag.fr")}/>
            </div>






        </div>
    )
}
